// Bridges the existing CPU depth field (lib/sand/DepthMap.ts) to the GPU as a
// single-channel R8 DataTexture the sand shader samples as footprint dents.
// The interaction logic (stamping, decay, reset wave) stays in DepthMap; this
// module only mirrors the float buffer into GPU-uploadable bytes.

import { DataTexture, RedFormat, UnsignedByteType, LinearFilter, ClampToEdgeWrapping } from 'three';

export type DepthLike = { width: number; height: number; data: Float32Array };

export function makeFootprintTexture(map: DepthLike): DataTexture {
  const bytes = new Uint8Array(map.width * map.height);
  const tex = new DataTexture(bytes, map.width, map.height, RedFormat, UnsignedByteType);
  tex.minFilter = LinearFilter;
  tex.magFilter = LinearFilter;
  tex.wrapS = ClampToEdgeWrapping;
  tex.wrapT = ClampToEdgeWrapping;
  tex.flipY = false;

  tex.needsUpdate = true;
  return tex;
}

export function syncFootprintTexture(tex: DataTexture, map: DepthLike): void {
  const bytes = tex.image.data as Uint8Array;
  const d = map.data;
  for (let i = 0; i < d.length; i++) {
    const v = d[i] <= 0 ? 0 : d[i] >= 1 ? 1 : d[i];
    bytes[i] = (v * 255) | 0;
  }
  tex.needsUpdate = true;
}
